const groupGlobalCompaniesFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const paragraphFields = fields
    .filter((field) => field.key.startsWith('paragraph-'))
    .sort((a, b) => a.sortOrder - b.sortOrder);

  return { introFields, paragraphFields };
};

export default groupGlobalCompaniesFields;
